import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import UnderlyingPriceTrailDocs from '../../../../documentation/UnderlyingPriceTrailDocumentation';

function UnderlyingPriceModule({ state }) {
  const [
    underlyingPriceTrail,
    dispatchUnderlyingPriceTrail,
    ,
    setUnderlyingPriceTrailEnabled,
  ] = state;

  const [amountDisplay, setAmountDisplay] = useState('');

  useEffect(() => {
    setUnderlyingPriceTrailEnabled(true);
  }, []);

  useEffect(() => {
    setAmountDisplay(underlyingPriceTrail.amount);
  }, [state]);
  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={UnderlyingPriceTrailDocs} /> 
        Underlying Price Trail
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Amount</p>
          <NumberInputWithUnit
            direction="left"
            type="number"
            value={amountDisplay}
            setValue={setAmountDisplay}
            onBlur={(value) => dispatchUnderlyingPriceTrail({ amount: value })}
          >
            $
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
UnderlyingPriceModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default UnderlyingPriceModule;
